import { Injectable } from '@angular/core';
import { ResizeObserver } from '@juggle/resize-observer';

@Injectable({
  providedIn: 'root',
})
export class ResizeObserverService {
  /* istanbul ignore next */
  getObserver(callback: ResizeObserverCallback): ResizeObserver {
    return new ResizeObserver(callback);
  }
}
